import {ModalContent} from '@chakra-ui/react';
import {useSelector} from 'react-redux';

export default function ChakraModalContent({children, ...props}) {
    const {darkMode} = useSelector((state) => state.settings)
    const modalBg = darkMode ? 'dark.tcap' : 'white'
    return <ModalContent {...props} bg={modalBg} >{children}</ModalContent>;
}
